import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

const StoreHead = ({
  googleIndex = true,
  metaDescription = null,
  metaTitle = null,
  noindex = false,
}) => (
  <NextSeo
    description={metaDescription}
    nofollow={!googleIndex}
    // googleIndex=false suppresses the entire store (admin setting);
    // noindex=true suppresses only this page variant (e.g., thin coupon count).
    noindex={!googleIndex || noindex}
    openGraph={{
      title: metaTitle,
      description: metaDescription,
    }}
    title={metaTitle}
  />
);

StoreHead.propTypes = {
  googleIndex: PropTypes.bool,
  metaDescription: PropTypes.string,
  metaTitle: PropTypes.string,
  noindex: PropTypes.bool,
};

export default StoreHead;
